import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import useFetch from '../useFetch';

// === Pages

function Landing() {
  return (
    <div className="page-wrapper">
      <div className="main-container about-page landing-page"></div>
      <div className="side-container about-page"></div>
    </div>
  );
}

export default Landing;
